module.exports = __webpack_public_path__ + "media/images/greenmapmarker-a9ead65fb2fc9c19e3cfda900683f430.png";